/// <reference path="DOMAttached.js" />

class RegisterHelp extends DOMAttached {
	constructor(el) {
		super(el);

		const listItems = this.el.querySelectorAll("li");
		listItems.forEach(curLi => {
			let inp = curLi.querySelector("input");
			if (!inp) {
				inp = curLi.querySelector("select");
			}
			const tooltip = curLi.querySelector(".registerHelpTooltip");
			if (inp && tooltip) {
				this.safeObserve(inp, 'focus', this.onFocusBlur.bind(this));
				this.safeObserve(inp, 'blur', this.onFocusBlur.bind(this));
			}
		});
	}

	onFocusBlur() {
		var data = $A(arguments);
		data.shift();
		if (data[0] == undefined) {
			return;
		}
		if (data[0].classList.contains('registerHelpTooltipShown')) {
			data[0].classList.remove('registerHelpTooltipShown');
		} else {
			data[0].classList.add('registerHelpTooltipShown');
		}
	}
}
